// extracted by mini-css-extract-plugin
module.exports =  {"saleStat":"saleStat__pKO5c","mainRange":"mainRange__BEBXV","tips":"tips__-Ia6m","queryBtn":"queryBtn__6TGpk","exportButton":"exportButton__h1qe8"};